import { CalculationStatus } from '@ydistri/api-sdk';
import { useMemo } from 'react';
import {
  isTemplateEditable,
  isTemplateOutdated,
  isTemplateRunning,
  calculationStatusToNiceString,
} from '@ydistri/utils';
import { useGetStatusesQuery } from '../apis/apiApplication';
import { useTemplateOrCalculationWithValue } from './useTemplateOrCalculationWithValue';

export interface TemplateStatusInfo {
  isRunning: boolean;
  isEditable: boolean;
  isOutdated: boolean;
  niceName: string;
  status: CalculationStatus;
}

export const useTemplateStatus = (): TemplateStatusInfo => {
  const templateOrCalculation = useTemplateOrCalculationWithValue('Template');
  const { data: statuses } = useGetStatusesQuery(templateOrCalculation.value);

  const templateStatus: CalculationStatus = statuses?.templateStatus ?? CalculationStatus.Outdated;

  return useMemo(
    () => ({
      isRunning: isTemplateRunning(templateStatus),
      isEditable: isTemplateEditable(templateStatus),
      isOutdated: isTemplateOutdated(templateStatus),
      niceName: calculationStatusToNiceString(templateStatus),
      status: templateStatus,
    }),
    [templateStatus],
  );
};
